import { Page } from "@/models/page-models/Page";

export const OrderDetails: Page = {
  "path": "order/:orderId",
  "name": "Order Details",
  "props": {
    "data": {
      "title": "Order Details",
      "printable": "FALSE",
      "url": "order/:orderId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_FtOrderDetails",
                  "variable": "fetchedData.selectedOrder.data",
                  "label": "Order Details",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrder}}",
                  "config": {
                    "totalQuantityProducedVariable": "fetchedData.balanceQuantity.data.totalQuantityProduced",
                    "averageProgressVariable": "fetchedData.progressSummary.averageProgress"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Request Transfer",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultFormValues",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultFormValues",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.transferForm"
                      },
                      "name": "copyDefaultFormValues"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "openTransferPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Request FG Transfer"
                      },
                      "name": "openTransferPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,{{fetchedData.outputFG.location.Factory.totalQuantity}},>,0)",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Production | Manager),||,fn(MATCH_ROLE,Production | Planner))",
              "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedOrder.data.status}},'),!==,'Invoice Issued'),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedOrder.data.status}},'),!==,'Under Production'))"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print Zebra Label",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyLabelDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.selectedOrder.data",
                        "arg2Key": "sourceFn",
                        "arg2Value": "getLabelDetails",
                        "arg3Key": "destinationKey",
                        "arg3Value": "fetchedData.labelDetails",
                        "arg4Key": "append",
                        "arg4Value": "TRUE",
                        "arg5Key": "destinationKeyType",
                        "arg5Value": "Object"
                      },
                      "name": "copyLabelDetails"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "openZebraPrintPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Print Zebra Label"
                      },
                      "name": "openZebraPrintPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(MATCH_ROLE,Production | Planner)"
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Process detail",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.createdBy.displayName",
                  "label": "Created By"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.createdAt",
                  "label": "Created",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.prodReport.createdAt}},show-time)"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.updatedAt",
                  "label": "Updated At",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.prodReport.updatedAt}},show-time)"
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Production Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.prodReport.productionDate}})"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.machine",
                  "label": "Machine"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.numberOfMen",
                  "label": "Number Of Men"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.standardSpeed",
                  "label": "Standard Speed"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.activeSpeed",
                  "label": "Active Speed"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.setupWaste",
                  "label": "Setup Waste"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.maintenanceWaste",
                  "label": "Maintenance Waste"
                },
                {
                  "type": "label",
                  "variable": "formData.trimWaste",
                  "label": "Trim Waste"
                },
                {
                  "type": "label",
                  "variable": "formData.productionWaste",
                  "label": "Production Waste"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.setupDT",
                  "label": "Setup DT"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.maintenanceDT",
                  "label": "Maintenance DT"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.productionDT",
                  "label": "Production DT"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.timeFrom",
                  "label": "Time From"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.timeTo",
                  "label": "Time To"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.timeSpent",
                  "label": "Time Spent"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "custom_ProductionReport",
                  "variable": "formData.prodReport.process",
                  "label": "Production Report",
                  "disabled": "TRUE",
                  "showIf": "{{fetchedData.orderProcesses.data.processes}}",
                  "config": {
                    "resetData": false,
                    "wipVariable": "fetchedData.goods.data",
                    "goodsVariable": "fetchedData.orderProcesses.data.goods",
                    "orderVariable": "formData.prodReport.factoryTicket.order",
                    "processesVariable": "fetchedData.orderProcesses.data.processes"
                  }
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Pending Production Report",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.createdBy.displayName",
                  "label": "Created By"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.createdAt",
                  "label": "Created",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.prodReport.createdAt}},show-time)"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.updatedAt",
                  "label": "Updated At",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.prodReport.updatedAt}},show-time)"
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Production Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.prodReport.productionDate}})"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.machine",
                  "label": "Machine"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.numberOfMen",
                  "label": "Number Of Men"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.standardSpeed",
                  "label": "Standard Speed"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.activeSpeed",
                  "label": "Active Speed"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.setupWaste",
                  "label": "Setup Waste"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.maintenanceWaste",
                  "label": "Maintenance Waste"
                },
                {
                  "type": "label",
                  "variable": "formData.trimWaste",
                  "label": "Trim Waste"
                },
                {
                  "type": "label",
                  "variable": "formData.productionWaste",
                  "label": "Production Waste"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.setupDT",
                  "label": "Setup DT"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.maintenanceDT",
                  "label": "Maintenance DT"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.productionDT",
                  "label": "Production DT"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.prodReport.timeFrom",
                  "label": "Time From"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.timeTo",
                  "label": "Time To"
                },
                {
                  "type": "label",
                  "variable": "formData.prodReport.timeSpent",
                  "label": "Time Spent"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "custom_ProductionReport",
                  "variable": "formData.prodReport.process",
                  "label": "Production Report",
                  "onChange": [
                    {
                      "executionOrder": 2,
                      "name": "copyExpectedProgress"
                    }
                  ],
                  "disabled": "fn(LOGICAL,{{fetchedData.enableEdit}},==,false)",
                  "showIf": "{{fetchedData.orderProcesses.data.processes}}",
                  "config": {
                    "resetData": false,
                    "wipVariable": "fetchedData.goods.data",
                    "goodsVariable": "fetchedData.orderProcesses.data.goods",
                    "orderVariable": "formData.prodReport.factoryTicket.order",
                    "processesVariable": "fetchedData.orderProcesses.data.processes"
                  }
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "expectedProgress",
                  "label": "Expected Progress",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,<span class=\"blue--text\">,{{fetchedData.expectedProgress.currentProgress}},%,</span> => <span class=\"green--text\">,{{fetchedData.expectedProgress.expectedProgress}},%</span>)"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Edit",
              "showIf": "fn(LOGICAL,{{fetchedData.enableEdit}},==,false)",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "enableEdit"
                }
              ]
            },
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "sendWarning",
                  "executeIf": "fn(LOGICAL,{{fetchedData.expectedProgress.expectedProgress}},>,110)"
                },
                {
                  "executionOrder": 2,
                  "name": "saveProductionReport",
                  "executeIf": "fn(LOGICAL,{{fetchedData.enableEdit}},==,true)"
                },
                {
                  "executionOrder": 3,
                  "name": "approveProductionReport"
                },
                {
                  "executionOrder": 4,
                  "name": "closePendingPrPopup"
                }
              ]
            },
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "rejectProductionReport"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Request FG Transfer",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.transferForm.locationFrom",
                  "label": "Location From",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.transferForm.locationTo",
                  "label": "Location To",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.transferForm.unitOfTransfer",
                  "label": "Unit Of Transfer",
                  "disabled": "FALSE"
                }
              ],
              "disabled": "TRUE"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Available Quantity",
                  "showIf": "{{fetchedData.transferForm.unitOfTransfer}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{fetchedData.selectedOrder.data}},{{fetchedData.outputFG}},{{fetchedData.outputFG.location.Factory.totalQuantity}},{{fetchedData.transferForm.unitOfTransfer}})",
                  "filterType": "unit",
                  "filterParam": "{{fetchedData.transferForm.unitOfTransfer}}"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.transferForm.quantity",
                  "label": "Enter Quantity",
                  "unit": "{{fetchedData.transferForm.unitOfTransfer}}",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "copyResolvedFormData",
                    "type": "fnCopyData",
                    "arg1Key": "sourceFn",
                    "arg1Value": "getResolvedFormData",
                    "arg2Key": "destinationKey",
                    "arg2Value": "formData",
                    "arg3Key": "destinationKeyType",
                    "arg3Value": "Object",
                    "arg4Key": "append",
                    "arg4Value": "TRUE"
                  },
                  "name": "copyResolvedFormData"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "submitGoodsTransferRequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/goods/transfer/request",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "submitGoodsTransferRequest"
                },
                {
                  "executionOrder": 3,
                  "pageFunction": {
                    "name": "closeFGTransferPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Request FG Transfer"
                  },
                  "name": "closeFGTransferPopup"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Order Progress",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.progressSummary.progressArray}}",
                  "items": "fetchedData.progressSummary.progressArray",
                  "headers": [
                    {
                      "value": "type",
                      "text": "Process",
                      "align": "center"
                    },
                    {
                      "value": "netWeight",
                      "text": "Expected Quantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.netWeight}})",
                      "align": "center"
                    },
                    {
                      "value": "progress",
                      "text": "Progress",
                      "type": "progress"
                    },
                    {
                      "value": "producedQty",
                      "text": "Produced Quantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.producedQty}})",
                      "align": "center"
                    },
                    {
                      "value": "approvedProductionReports",
                      "text": "Approved Production Reports",
                      "type": "custom-url",
                      "multipleItemsVariable": "approvedProcessProductionReports",
                      "itemParam": "_id",
                      "customUrlFns": [
                        {
                          "executionOrder": 1,
                          "name": "getProductionReport"
                        },
                        {
                          "executionOrder": 2,
                          "name": "openProcessPopup"
                        }
                      ],
                      "align": "center"
                    },
                    {
                      "value": "pendingProductionReports",
                      "text": "Pending Production Reports",
                      "type": "custom-url",
                      "multipleItemsVariable": "pendingProcessProductionReports",
                      "itemParam": "_id",
                      "customUrlFns": [
                        {
                          "executionOrder": 1,
                          "name": "getProductionReport"
                        },
                        {
                          "executionOrder": 2,
                          "name": "openPendingPrPopup"
                        },
                        {
                          "executionOrder": 2,
                          "name": "cancelEdit"
                        },
                        {
                          "executionOrder": 2,
                          "name": "copyExpectedProgress"
                        }
                      ],
                      "align": "center"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Production | Manager),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Production | Planner)))",
          "label": "Order Progress"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "FG Transfer History",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.fgHistory}}",
                  "items": "fetchedData.fgHistory.data",
                  "headers": [
                    {
                      "value": "updatedAt",
                      "text": "Transfer Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                    },
                    {
                      "value": "__item.locationFrom",
                      "text": "Location",
                      "type": "formula",
                      "formula": "{{__item.locationFrom}} -> {{__item.locationTo}}"
                    },
                    {
                      "value": "quantity",
                      "text": "Transfer Quantity",
                      "type": "formula",
                      "filterType": "unit",
                      "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{fetchedData.selectedOrder.data}},{{__item.rawMaterial}},{{__item.quantity}})",
                      "filterParam": "{{fetchedData.selectedOrder.data.unit.unit2}}"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "{{fetchedData.fgHistory}}",
          "label": "FG Transfer History"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Invoices History",
                  "disabled": "FALSE",
                  "items": "fetchedData.selectedOrder.data.invoices",
                  "headers": [
                    {
                      "value": "invoice.createdAt",
                      "text": "Invoice Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.invoice.createdAt}})"
                    },
                    {
                      "value": "invoice._id",
                      "text": "Invoice #",
                      "type": "url",
                      "url": "/invoice/{{__item.invoice._id}}"
                    },
                    {
                      "value": "invoice.loadingManifests.0",
                      "text": "Loading Manifest #",
                      "type": "url",
                      "url": "/loading-manifest/{{__item.invoice.loadingManifests.0}}"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Invoice History"
        },
        {
          "type": "popupGroup",
          "label": "Print Zebra Label",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.customer",
                  "label": "Customer"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.itemName",
                  "label": "Item"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.lotNumber",
                  "label": "Lot#/Job"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.palletType",
                  "label": "Pallet Type"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.irms",
                  "label": "IRMS#/GCAS#"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.supplierCode",
                  "label": "Supplier Code"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.quantity",
                  "label": "Quantity"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.labelDetails.numberOfRolls",
                  "label": "No. Of Rolls / Packets"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.labelDetails.quantity",
                  "label": "QUANTITY",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.labelDetails.numberOfRolls",
                  "label": "NO. OF ROLLS/PKTS",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.labelDetails.weight",
                  "label": "Weight (KG)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.labelDetails.numberOfLabels",
                  "label": "No. of Zebra Labels (No. of Cartons)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "fetchedData.labelDetails.shiftDate",
                  "label": "Production Date",
                  "disabled": "FALSE",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyExpiryDate",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getExpiryDate",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.labelDetails",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyExpiryDate"
                    }
                  ]
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.labelDetails.expiryDate",
                  "label": "Expiry Date",
                  "disabled": "FALSE",
                  "showResetOption": true
                },
                {
                  "type": "input",
                  "variable": "fetchedData.labelDetails.shiftNumber",
                  "label": "Shift Number(00 - 99)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Print Old Label",
              "disableIf": "fn(LOGICAL,fn(MULTIPLY,{{fetchedData.labelDetails.quantity}},{{fetchedData.labelDetails.numberOfRolls}}),==,0)",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "printLabel",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/printer/generateNewLabel1",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.labelDetails",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "printLabel"
                }
              ]
            },
            {
              "label": "Print New Label",
              "disableIf": "fn(LOGICAL,fn(MULTIPLY,{{fetchedData.labelDetails.quantity}},{{fetchedData.labelDetails.numberOfRolls}}),==,0)",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "printLabel",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/printer/generateNewLabel",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.labelDetails",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "printLabel"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getOrderDetails"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersProgress",
        "executeIf": "fn(LOGICAL,fn(NOT,fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Outbound Warehouse),||,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))),||,fn(MATCH_ROLE,Customer Service | Artwork)),||,fn(MATCH_ROLE,QA | Manager))),&&,{{fetchedData.selectedOrder.data.factoryTicket}})"
      },
      {
        "executionOrder": 2,
        "name": "getOrderProcesses",
        "executeIf": "fn(LOGICAL,fn(NOT,fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Outbound Warehouse),||,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))),||,fn(MATCH_ROLE,Customer Service | Artwork)),||,fn(MATCH_ROLE,QA | Manager))),&&,{{fetchedData.selectedOrder.data.factoryTicket}})"
      },
      {
        "executionOrder": 3,
        "name": "copyOrderProgress",
        "executeIf": "{{fetchedData.ordersProgress}}"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getBalanceQuantity",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/order/{{__params.orderId}}/balance-quantity",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.balanceQuantity"
        },
        "name": "getBalanceQuantity",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Artwork),||,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyOutputFG",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getOutputFg",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyOutputFG",
        "executeIf": "{{fetchedData.orderProcesses.data.goods}}"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "getFgTransferHistory",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/goods/transfer/{{fetchedData.outputFG._id}}?status=approved",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.fgHistory"
        },
        "name": "getFgTransferHistory",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Production | Manager),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Production | Planner))),&&,{{fetchedData.selectedOrder.data.factoryTicket}})"
      }
    ],
    "functions": [
      {
        "name": "getOrderDetails",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__params.orderId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.selectedOrder"
      },
      {
        "name": "getOrdersProgress",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/ft-progress/{{fetchedData.selectedOrder.data.factoryTicket}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersProgress"
      },
      {
        "name": "getOrderProgress",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "progressSummary": "fn(HELPER_FN,orderProgress,{{fetchedData.ordersProgress.data}},{{fetchedData.processes}})"
        },
        "useFormula": true
      },
      {
        "name": "copyOrderProgress",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrderProgress",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getOrderProcesses",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/factoryticket/orderprocess?id={{fetchedData.selectedOrder.data._id}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.orderProcesses",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"convertProcesses\",\"executionOrder\":1}]",
        "arg4Key": "addToState",
        "arg4Value": "{\"actionName\":\"addMultipleGoods\",\"variable\":\"fetchedData.orderProcesses.data.goods\"}"
      },
      {
        "name": "convertProcesses",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.orderProcesses.data",
        "arg2Key": "sourceFn",
        "arg2Value": "getConvertedProcesses",
        "arg3Key": "destinationKey",
        "arg3Value": "fetchedData",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object",
        "arg5Key": "append",
        "arg5Value": "TRUE"
      },
      {
        "name": "getConvertedProcesses",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "processes": "fn(TO_ARRAY,{{__selectedObject.processes}})"
        },
        "useFormula": true
      },
      {
        "name": "openProcessPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Process detail"
      },
      {
        "name": "copySelectedProcess",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "openPendingPrPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Pending Production Report"
      },
      {
        "name": "closePendingPrPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Pending Production Report"
      },
      {
        "name": "getProductionReport",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/productionreport/{{__item._id}}",
        "arg2Key": "storeInVar",
        "arg2Value": "formData",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "getProductionReportData",
        "arg4Key": "serviceConfig",
        "arg4Value": "{\"service\":\"GET_WIP\",\"args\":[\"formData.prodReport\"]}"
      },
      {
        "name": "getProductionReportData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "prodReport": "__selectedObject.data.0"
        }
      },
      {
        "name": "approveProductionReport",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/production/reports/{{formData.prodReport._id}}/approve",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "closePendingPrPopup"
      },
      {
        "name": "cancelEdit",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getCancelEditFlag",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getCancelEditFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "enableEdit": "fn(LOGICAL,1,!=,1)"
        },
        "useFormula": true
      },
      {
        "name": "enableEdit",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getEnableEditFlag",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getEnableEditFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "enableEdit": "fn(LOGICAL,1,==,1)"
        },
        "useFormula": true
      },
      {
        "name": "saveProductionReport",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/productionreport",
        "arg2Key": "postData",
        "arg2Value": "formData.prodReport"
      },
      {
        "name": "copyExpectedProgress",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getExpectedProgress",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getExpectedProgress",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "expectedProgress": "fn(HELPER_FN,expectedProgress,{{formData.prodReport}},{{fetchedData.progressSummary.progressArray}})"
        },
        "useFormula": true
      },
      {
        "name": "sendWarning",
        "type": "fnOpenSnackbar",
        "serverMessage": "Expected Output is more than 10% tolerance.",
        "color": "error"
      },
      {
        "name": "rejectProductionReport",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/production/reports/{{formData.prodReport._id}}/reject",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getOutputFg",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "outputFG": "fn(HELPER_FN,orderFg,{{fetchedData.orderProcesses.data}})"
        },
        "useFormula": true
      },
      {
        "name": "getLocationsArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "locations": "fn(TO_ARRAY,{{__selectedObject}})"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "unitOfTransfer": "{{fetchedData.outputFG.packingMode.0.unit1}}",
          "locationTo": "Warehouse",
          "locationFrom": "Factory",
          "rawMaterial": "{{fetchedData.outputFG._id}}"
        },
        "useFormula": true
      },
      {
        "name": "getResolvedFormData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "rawMaterial": "{{fetchedData.transferForm.rawMaterial}}",
          "unitOfTransfer": "{{fetchedData.transferForm.unitOfTransfer}}",
          "locationTo": "{{fetchedData.transferForm.locationTo}}",
          "locationFrom": "{{fetchedData.transferForm.locationFrom}}",
          "quantity": "fn(HELPER_FN,sellingUnitQuantityToKg,{{fetchedData.outputFG}},{{fetchedData.transferForm.quantity}},{{fetchedData.transferForm.unitOfTransfer}},{{fetchedData.outputFG.location.Factory.totalQuantity}})"
        },
        "useFormula": true
      },
      {
        "name": "getLabelDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "palletType": "NONE",
          "quantity": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.product.packingMode.1.quantity}},>,0),fn(MULTIPLY,{{__selectedObject.product.packingMode.0.quantity}},{{__selectedObject.product.packingMode.1.quantity}}),{{__selectedObject.product.packingMode.0.quantity}})",
          "irms": "{{__selectedObject.product.customerItemId}}",
          "numberOfRolls": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.product.packingMode.1.quantity}},>,0),{{__selectedObject.product.packingMode.1.quantity}},1)",
          "itemName": "fn(HELPER_FN,productAlias,{{__selectedObject.product}},false)",
          "customer": "{{__selectedObject.customer.name}}",
          "supplierCode": "{{__selectedObject.customer.supplierCode}}",
          "lotNumber": "{{__selectedObject._id}}",
          "numberOfLabels": "1",
          "productLine": "{{__selectedObject.productLine}}",
          "customerId": "{{__selectedObject.customer._id}}",
          "shiftDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)",
          "expiryDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},fn(CONDITIONAL,fn(LOGICAL,fn(LOGICAL,'{{__selectedObject.productLine}}',==,'Ribbon'),||,fn(LOGICAL,'{{__selectedObject.productLine}}',==,'Wet Wipes')),12,6),month),date-picker)"

        },
        "useFormula": true
      },
      {
        "name": "getExpiryDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "expiryDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{fetchedData.labelDetails.shiftDate}},fn(CONDITIONAL,fn(LOGICAL,fn(LOGICAL,'{{fetchedData.labelDetails.productLine}}',==,'Ribbon'),||,fn(LOGICAL,'{{fetchedData.labelDetails.productLine}}',==,'Wet Wipes')),12,6),month),date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,QA_MANAGER,PRODUCTION_MANAGER,PRODUCTION_PLANNER,CUSTOMER_SERVICE_ARTWORK,CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,GENERAL_MANAGER",
  "visible": false
}